/**
 * 门户主题（对齐 Element UI 自定义主题：改 $--color-primary）
 * 参考管理端 wl-vue-manager/src/config/appThemes.js
 */

export const THEME_STORAGE_KEY = 'wl_portal_theme_v1'

export const COLOR_THEMES = [
  {
    id: 'boy',
    label: '男生蓝',
    desc: '冷静商务',
    primary: '#2F6FED',
    primaryHover: '#4A84F0',
    primaryActive: '#2459C9',
    primaryLight: '#E8F0FE'
  },
  {
    id: 'girl',
    label: '女生粉',
    desc: '柔和明快',
    primary: '#E45D8C',
    primaryHover: '#EA7AA0',
    primaryActive: '#C94A76',
    primaryLight: '#FDECF2'
  },
  {
    id: 'lavender',
    label: '薰衣草紫',
    desc: '温柔仙气',
    primary: '#9B7EBD',
    primaryHover: '#B098D0',
    primaryActive: '#8268A3',
    primaryLight: '#F3EEF8'
  },
  {
    id: 'peach',
    label: '蜜桃粉',
    desc: '甜美暖意',
    primary: '#E88B7A',
    primaryHover: '#EFA396',
    primaryActive: '#D07060',
    primaryLight: '#FDF0ED'
  },
  {
    id: 'rosewood',
    label: '豆沙玫瑰',
    desc: '高级柔美',
    primary: '#C97B84',
    primaryHover: '#D6979E',
    primaryActive: '#B0636C',
    primaryLight: '#F9EFF0'
  },
  {
    id: 'sky',
    label: '晴空蓝',
    desc: '清透轻快',
    primary: '#6BA3D8',
    primaryHover: '#87B6E1',
    primaryActive: '#5289BC',
    primaryLight: '#EBF4FA'
  },
  {
    id: 'classic',
    label: '经典青',
    desc: 'Element 默认青',
    primary: '#409EFF',
    primaryHover: '#66B1FF',
    primaryActive: '#3A8EE6',
    primaryLight: '#ECF5FF'
  },
  {
    id: 'orange',
    label: '活力橙',
    desc: '醒目强调',
    primary: '#E67E22',
    primaryHover: '#EB9548',
    primaryActive: '#C96A1A',
    primaryLight: '#FDF0E5'
  },
  {
    id: 'teal',
    label: '松柏绿',
    desc: '清爽稳重',
    primary: '#0D9488',
    primaryHover: '#14B8A6',
    primaryActive: '#0F766E',
    primaryLight: '#E6F7F5'
  },
  {
    id: 'ink',
    label: '墨蓝',
    desc: '深色沉稳',
    primary: '#1E4E79',
    primaryHover: '#2A6294',
    primaryActive: '#163A5A',
    primaryLight: '#E8EEF4'
  },
  {
    id: 'crimson',
    label: '赤焰红',
    desc: '热情醒目',
    primary: '#C0392B',
    primaryHover: '#D45142',
    primaryActive: '#A93226',
    primaryLight: '#F9EBEA'
  },
  {
    id: 'amber',
    label: '琥珀金',
    desc: '暖色点缀',
    primary: '#C48A00',
    primaryHover: '#D4A017',
    primaryActive: '#A67400',
    primaryLight: '#FBF5E0'
  }
]

export const APPEARANCE_MODES = [
  {
    id: 'day',
    label: '白天',
    icon: 'el-icon-sunrise',
    desc: '明亮标准'
  },
  {
    id: 'eyecare',
    label: '护眼',
    icon: 'el-icon-view',
    desc: '柔和豆沙绿'
  }
]

export const DEFAULT_THEME = {
  colorId: 'classic',
  modeId: 'day'
}

export function getColorTheme(id) {
  return COLOR_THEMES.find(t => t.id === id) || COLOR_THEMES.find(t => t.id === DEFAULT_THEME.colorId)
}

export function getAppearanceMode(id) {
  return APPEARANCE_MODES.find(t => t.id === id) || APPEARANCE_MODES.find(t => t.id === DEFAULT_THEME.modeId)
}

export function readStoredTheme() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY)
    if (!raw) return { ...DEFAULT_THEME }
    const parsed = JSON.parse(raw)
    let modeId = parsed.modeId
    if (modeId === 'night') modeId = 'day'
    const colorId = getColorTheme(parsed.colorId).id
    modeId = getAppearanceMode(modeId).id
    return { colorId, modeId }
  } catch (e) {
    return { ...DEFAULT_THEME }
  }
}

export function writeStoredTheme(theme) {
  const colorId = getColorTheme(theme.colorId).id
  const modeId = getAppearanceMode(theme.modeId).id
  const next = { colorId, modeId }
  localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(next))
  return next
}
